const CloverApiVersion = require('@/lib/PaymentMethods/Clover/Enums/CloverApiVersion');
const CloverAxiosInstance = require('@/lib/PaymentMethods/Clover/CloverAxiosInstance');
const CloverConfig = require('@/lib/PaymentMethods/Clover/CloverConfig');

/**
 * Create a CloverAxiosInstance instance with all the required headers and baseURL set.
 * We need a different instance for each Clover API we interact with.
 * In addition, some API requests will require the Idempotency-Key header to be set, but we do this on the instance.
 *
 * @param {CloverConfig} cloverConfig
 * @param {string} type
 *
 * @return {CloverAxiosInstance}
 */
const cloverAxiosInstanceFactory = (cloverConfig, type) => {
    if (!cloverConfig || !(cloverConfig instanceof CloverConfig)) {
        throw new Error('cloverAxiosInstanceFactory requires an instance of CloverConfig.');
    }

    if (!Object.values(CloverApiVersion).includes(type)) {
        throw new Error('cloverAxiosInstanceFactory requires a valid type.');
    }

    // The default headers used by all API versions.
    let config = {
        baseURL: cloverConfig.baseUrl,
        headers: {
            accept: 'application/json',
            // Authorization: `Bearer ${cloverConfig.authBearerToken}`,
        },
    };

    if (type === CloverApiVersion.REST_PAY_DISPLAY) {
        config.headers['content-type'] = 'application/json';
        config.headers['X-Clover-Timeout'] = cloverConfig.xCloverTimeout;
        config.headers['X-Clover-Device-Id'] = cloverConfig.xCloverDeviceId;
        config.headers['X-POS-Id'] = cloverConfig.xPosId;
    }

    return new CloverAxiosInstance(type, config);
};

module.exports = cloverAxiosInstanceFactory;
